import React, { useRef } from 'react';
import Layout from '../../Layout';
import { Image, Row, Col } from 'react-bootstrap';
import '../css/service.css';
import { useNavigate } from 'react-router-dom';


const services = [
    {
        id: '01',
        title: 'Health, Safety, and Environmental (HSE) Consultancy',
        desc: 'Risk assessments, safety audits, and compliance with industry regulations.',
    },
    {
        id: '02',
        title: 'Project Management & Advisory',
        desc: 'Planning, execution, and monitoring of projects to ensure efficiency and cost-effectiveness.',
    },
    {
        id: '04',
        title: 'Engineering & Technical Support',
        desc: 'Expert advice on mechanical, civil, and structural engineering solutions.',
    },
    {
        id: '05',
        title: 'Regulatory & Compliance Consulting',
        desc: 'Ensuring adherence to industry laws, permits, and safety standards.',
    },
    {
        id: '06',
        title: 'Workplace Safety Management',
        desc: 'Implementation of safety policies, risk assessments, and accident prevention strategies.',
    },
    {
        id: '07',
        title: 'Supply of Safety Equipment',
        desc: 'Provision of PPE, fire extinguishers, gas detectors, and emergency response kits.',
    },
    {
        id: '08',
        title: 'Environmental Compliance & Waste Management',
        desc: 'Hazardous waste disposal, spill control, and pollution mitigation.',
    },
    {
        id: '09',
        title: 'Fire & Gas Safety Systems',
        desc: 'Installation and maintenance of fire suppression and gas detection systems.',
    },
    {
        id: '10',
        title: 'HSE Training & Consultancy',
        desc: 'Safety awareness programs, emergency drills, and regulatory compliance training.',
    },
    // …add more as needed
];

const EnvironmentalSafety = () => {
  const navigate = useNavigate();


  const navToPage =()=> {
    navigate('/contact-us');
 }

    const scrollRef = useRef(null);

    const scroll = (direction) => {
        console.log("i scrolled ", scrollRef.current)
        if (scrollRef.current) {
            const scrollAmount = scrollRef.current.offsetWidth * 0.6; // 60% of container width
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth',
            });
        }
    };

    return (
        <Layout>

            <section className='abt-container'>
                <div className='abt-header'>
                    <Image src="/safety.png" className="d-inline-block  img-fluid wow fadeInDown" data-wow-duration="0.5s" alt="inovative" />

                    <div className='header-content'>
                        <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1s'>HSE Solutions<br/>and Consultancy</h1>
                        <button  onClick={navToPage} className='cta wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Request Consultation →</button>
                    </div>

                </div>
            </section>

            <section className='child-container serv'>
                <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>We specialize in delivering HSEQ Solutions and Consultancy Services designed to meet the complex demands in a challenging environment.</h1>
            </section>


            <section className='info-container'>
                <div className="servflex">
                    <div className="">
                        <div className="serv-line" />
                    </div>

                    <div className=''>
                        <p className='servParagText wow animate__animated animate__fadeInDown' data-wow-duration="1.5s" >Our goal is to help you protect your workforce, assets and reputation while maintaining full regulatory compliance and operational continuity.</p>
                        {/* <br className='hide' /> */}
                    </div>
                </div>
            </section>


            <section className='info-container'>
                <div className='sectionTwo mt-5'>
                    <Image src="/consult.jpg" className="d-inline-block  img-fluid  wow animate__animated animate__fadeInUp" data-wow-duration="1.5s" alt="inovative" />
                </div>

            </section>



            <section className='sectionThree'>
                <div className='serv-container'>
                    <div className='sectionIn'>
                        <div className='sevThreeOne'>
                            {/* <span className='parag'>Scope of Services</span> */}
                            <h1  className='wow animate__animated animate__fadeIn' data-wow-duration='1s' style={{ fontWeight: "200" }}>Scope of HSE Solutions and Consultancy</h1>
                        </div>
                        <div className='sevThreeTwo'>
                            <div className='d-flex gap-2'>
                                <div onClick={() => scroll('left')} className='social-handle'>
                                    <span>&larr;</span>
                                </div>
                                <div onClick={() => scroll('right')} className='social-handle'>
                                    <span>&rarr;</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="cardParent" ref={scrollRef}>
                        {services.map((svc, i) => {

                            const [firstWord, ...restWords] = svc.title.split(' ');
                            const restTitle = restWords.join(' ');
                            const delay = (i * 0.5).toFixed(1) + 's';

                            return (
                                <div key={svc.id} className="servCard wow animate__animated animate__fadeInRight"
                                    data-wow-delay={delay}>
                                    <div className="servCardContent">
                                        <h3>
                                            {firstWord}
                                            <br />
                                            {restTitle}
                                        </h3>
                                        <p>{svc.desc}</p>
                                        <button onClick={navToPage} className="cta">Request Service →</button>

                                        <div className='dflex align-items-end'>
                                            <span className="servCardNumber">{svc.id}</span>
                                        </div>
                                    </div>
                                </div>
                            )

                        })}
                    </div>

                </div>
            </section>



        </Layout>
    );
};

export default EnvironmentalSafety;